import styled from "styled-components";

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.4rem;
  padding: 0.3rem 0.5rem;
  border-radius: 2rem;
  color: ${({ theme }) => theme.styleGuide.colors.white};
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[500]};
`;
